import { GlobalCard } from '@global-engineering-shared/gweb-material-global';
import { WarningIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';
import { useMemo } from 'react';

import useStyles from 'components/DraftErrorsCard/DraftErrorsCard.styles';
import { DraftError } from 'types/draftError';
import { DraftErrorType } from 'types/entityType';
import { groupDraftErrorsByType } from 'utils/groupDraftErrorsByType';

import DraftErrorsCardSection from './DraftErrorsCardSection';

export interface DraftErrorsCardProps {
  errors: DraftError[] | undefined;
}

const DraftErrorsCard = ({ errors }: DraftErrorsCardProps) => {
  const classes = useStyles();

  const groupedErrors = useMemo(() => groupDraftErrorsByType(errors), [errors]);

  const sections = [
    {
      type: DraftErrorType.MISSING_DATA,
      title: 'Missing Information',
      subSectionTitle: 'The following information is missing:',
    },
    {
      type: DraftErrorType.VALIDATION_ERROR,
      title: 'Validation Errors',
      subSectionTitle: 'The following validation errors were found:',
    },
    {
      type: DraftErrorType.SSP_VALIDATION_ERROR,
      title: 'SSP Validation Errors',
      subSectionTitle: 'The following SSP validation errors were found:',
    },
    {
      type: DraftErrorType.APPLICATION_ERROR,
      title: 'Application Errors',
      subSectionTitle: 'The following application errors were found:',
    },
  ];

  const defaultMultiErrorTitle = 'Error';

  const visibleSections = sections.filter((section) => groupedErrors[section.type]?.length);
  const title = visibleSections.length === 1 ? visibleSections[0].title : defaultMultiErrorTitle;

  return (
    <GlobalCard className={classes.card}>
      <Typography variant="h5" fontWeight="bold">
        <Box className={classes.alertIcon}>
          <WarningIcon data-testid="AlertStatusHeavy" />
        </Box>
        {title}
      </Typography>
      {visibleSections.map((section) => (
        <DraftErrorsCardSection
          key={section.type}
          errors={groupedErrors[section.type]}
          title={section.subSectionTitle}
        />
      ))}
    </GlobalCard>
  );
};

export default DraftErrorsCard;
